<template>
  <div class="search">
    <FilterModal
      :show="modalFilter"
      @modal="toggleFilter"
      @filter="
        (params) => {
          filters = params;
          endSearchContent = false;
          toggleFilter();
          searchPage = 1;
          runSearch(1, true);
          $emit('search', searchText || (hasActiveFilters ? 'f' : ''));
        }
      "
      :authorsFromGet="filters.authors"
    />
    <div class="container search-container">
      <div class="search-input">
        <input
          type="text"
          name="search"
          placeholder="Ключевое слово"
          v-model="searchText"
          @input="$emit('search', searchText || (hasActiveFilters ? 'f' : ''))"
        />
        <div
          class="icon"
          @click="toggleFilter"
          :class="{
            active:
              filters?.categories?.length > 0 || filters?.authors?.length > 0,
          }"
        >
          <FilterIcon />
        </div>
      </div>
      <AuthorInfoBlock
        v-if="authorBio"
        :bio="authorBio"
        :poster-url="authorPosterUrl"
      />
      <div v-if="searchText || hasActiveFilters" class="search-desc">
        <div class="title">Результаты поиска — {{ searchCount }}</div>
      </div>
      <div class="search-wrap" v-if="(searchText || hasActiveFilters) && searchResult.length > 0">
        <div
          v-for="searchItem in searchResult"
          :key="searchItem.id"
          class="search-item"
          @click="$emit('openArticle', searchItem.id)"
        >
          <div class="search-item__image">
            <img
              v-if="searchItem.poster_url"
              :src="searchItem.poster_url"
              :alt="searchItem.title"
            />
          </div>
          <div class="search-item__content">
            <div class="search-item__title">
              {{ searchItem.title }}
            </div>
            <div class="search-item__author">
              {{ searchItem.author.name }}
            </div>
          </div>
        </div>
      </div>
      <ObserverBlock @intersect="intersected" />
    </div>
  </div>
</template>

<script>
import ObserverBlock from '@/components/blocks/observer/ObserverBlock.vue';
import AuthorInfoBlock from '@/components/blocks/author/AuthorInfoBlock.vue';
import FilterIcon from '@/components/icons/FilterIcon.vue';
import FilterModal from '@/components/modal/FilterModal.vue';
import { getAuthor, getPosts } from '@/functions/API';

export default {
  name: 'SearchBlock',
  components: {
    ObserverBlock,
    AuthorInfoBlock,
    FilterIcon,
    FilterModal,
  },
  data() {
    return {
      author: null,
      searchText: '',
      endContent: false,
      endSearchContent: false,
      page: 0,
      searchPage: 0,
      searchResult: [],
      searchCount: 0,
      modalFilter: false,
      filters: {
        categories: [],
        authors: [],
      },
    };
  },
  mounted() {
    if (this.$route.query.author_id && this.$route.query.author_name) {
      this.runQuerySearch();
    }
  },
  computed: {
    hasActiveFilters() {
      return this.filters.categories?.length > 0 || this.filters.authors?.length > 0;
    },
    activeAuthorId() {
      if (this.filters.authors?.length === 1) {
        return this.filters.authors[0];
      }
      return null;
    },
    authorBio() {
      return this.normalizeText(this.author?.bio);
    },
    authorPosterUrl() {
      return this.normalizeText(this.author?.poster_url);
    },
  },
  watch: {
    activeAuthorId: {
      immediate: true,
      handler(id) {
        this.author = null;
        if (id) {
          getAuthor(id, (res) => {
            if (res !== false) {
              this.author = res;
            }
          });
        }
      },
    },
    searchText() {
      this.endSearchContent = false;
      this.searchPage = 1;
      this.runSearch(1, true);
    },
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery.author_id && newQuery.author_name) {
          this.runQuerySearch();
        }
      },
    },
  },
  methods: {
    normalizeText(value) {
      if (value == null || typeof value !== 'string') {
        return '';
      }
      const trimmed = value.trim();
      return trimmed.length > 0 ? trimmed : '';
    },
    runQuerySearch() {
      this.filters.authors = [this.$route.query.author_id];
      this.searchText = this.$route.query.author_name;
      this.endSearchContent = false;
      this.searchPage = 1;
      this.runSearch(1, true);
      this.$emit('search', this.searchText);
    },
    intersected() {
      if (!this.endSearchContent && (this.searchText || this.hasActiveFilters)) {
        this.inlineLoaderShow = true;
        this.searchPage += 1;
        this.runSearch(this.searchPage);
      }
    },
    toggleFilter() {
      this.modalFilter = !this.modalFilter;
      const body = document.getElementsByTagName('body')[0];
      if (body) {
        if (this.modalFilter) {
          body.classList.add('fix');
        } else {
          body.classList.remove('fix');
        }
      }
    },
    runSearch(page, clear = false) {
      const req = {};
      if (this.filters.categories?.length > 0) {
        req.category_id = this.filters.categories;
      }
      if (this.filters.authors?.length > 0) {
        req.author_id = this.filters.authors;
      }
      if (this.searchText.length > 0) {
        req.search = this.searchText;
      }
      getPosts(page, req, (res, meta) => {
        if (res !== false) {
          if (clear) {
            this.searchResult = res;
            this.searchCount = meta.total;
          } else {
            if (this.searchResult.length > 0) {
              this.searchResult = this.searchResult.concat(res);
            } else {
              this.searchResult = res;
            }
          }
          if (res?.length < 1) {
            this.endSearchContent = true;
          }
          this.pageLoaderShow = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  &-input {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    input {
      width: 100%;
      height: 40px;
      border: none;
      border-radius: 8px;
      background-color: var(--color-gray-light);
      padding: 0 20px;
      color: var(--color-black);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
      &::placeholder {
        color: var(--color-gray);
      }
    }
    .icon {
      position: relative;
      svg {
        color: var(--color-gray);
        width: 24px;
        height: 24px;
        min-width: 24px;
        min-height: 24px;
        cursor: pointer;
      }
      &.active {
        &::before {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: var(--color-blue);
        }
      }
    }
  }
  &-wrap {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  &-desc {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 24px;
  }
  &-item {
    display: flex;
    align-items: stretch;
    background-color: var(--color-gray-light);
    border-radius: 8px;
    gap: 16px;
    min-height: 96px;
    cursor: pointer;
    &__image {
      width: 100%;
      height: auto;
      max-width: 72px;
      min-width: 72px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
        background-color: var(--color-gray);
      }
    }
    &__content {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 6px;
    }
    &__title {
      color: var(--color-black);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    &__author {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
  }
}
</style>
